'use strict';

import AxiosURLSearchParams from '../../../helpers/AxiosURLSearchParams.js';
export default typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;



// WEBPACK FOOTER //
// ./~/axios/lib/platform/browser/classes/URLSearchParams.js